<template>
  <div>
    <LeftListSupplier :pos="3"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li">
            <router-link to="/supplier-equity" class="txt">会员权益</router-link>
          </li>
          <li class="li">
            <router-link to="/info-recharge" class="txt">在线购买</router-link>
          </li>
          <li class="li on">
            <router-link to="/info-record" class="txt">交易记录</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="m-infobox7">
            <div class="g-titin1">交易记录：</div>
            <div class="table">
              <table class="">
                <thead>
                  <tr>
                    <th style="width: 20%">会员名</th>
                    <th style="width: 20%">套餐类型</th>
                    <th style="width: 20%">充值时间</th>
                    <th style="width: 20%">充值金额</th>
                    <th>有效期至</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data" :key="item.id">
                    <td>{{ item.userInfo.realname }}</td>
                    <td>{{ item.reason }}</td>
                    <td>{{ item.createtime }}</td>
                    <td>￥ {{ item.price }}</td>
                    <td>{{ (item.vipTimeAfter||'').split(' ')[0]}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="g-pagebox">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="dataCount"
                :page-size.sync="filter.pageSize"
                :current-page.sync="filter.page"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import {getApiRes} from "@/api/apiUtil";
import apiYrVipLog from "@/api/yrVipLog";
export default {
  components: {
    LeftListSupplier,
  },
  data() {
    return {
      filter: {
        page: 1,
        pageSize: 20,
        isUserInfo: true,
      },
      dataCount: 0,
      data: [],
    };
  },
  computed: {},
  watch: {
    filter: {
      handler() {
        this.load()
      },
      deep: true
    }
  },
  mounted() {
    this.load(1)
  },
  methods: {
    async load(page = undefined){
      if(page) this.filter.page = page
      let  re = await getApiRes(apiYrVipLog.getList(this.filter.page, this.filter.pageSize,[['type','=',1]],'',[],this.filter),0,1)
      if(re.code == 0){
        this.data = re.data
        this.dataCount = re.count
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
